<template>
  <div
    class="bg-secondary-9 rounded p-3 d-flex justify-content-center align-items-center"
  >
    <span class="color-secondary-6 font-16 font-weight-normal">
      {{ message }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'NotAvailableSpace',
  props: {
    message: {
      type: String,
      default: () => '',
    },
  },
};
</script>
